import initialState from '../store/initialState';
import { IAuthState } from './types';
import { SET_AUTH_LOGIN_SUCCESS, ISetAuthLoginSuccessAction, SET_USER_TYPE, ISetUserTypeAction, SET_AUTH_LOGOUT, ISetAuthLogoutAction } from './actions';

type HandledActions = ISetAuthLoginSuccessAction | ISetUserTypeAction | ISetAuthLogoutAction;

export const authReducer = (state: IAuthState = initialState.auth, action: HandledActions): IAuthState => {
  switch (action.type) {
    case SET_AUTH_LOGIN_SUCCESS:
      // action.payload.JWT = tamperJwtSub(action.payload.JWT, 'b34418c2-60d1-705a-055f-30220262a7b0');
      return {
        ...state,
        isAuthenticated: true,
        ...action.payload,
      };

    case SET_USER_TYPE:
      return { ...state, userType: action.payload };

    case SET_AUTH_LOGOUT:
      return initialState.auth;

    default:
      return state;
  }
};

/*
// Helper to tamper the sub property of a JWT
function tamperJwtSub(token: string, newSub: string): string {
  try {
    const parts = typeof token === 'string' ? token.split('.') : [];
    const decoded = parts.length >= 2 ? decodeJwtPayload(token) : null;
    if (!decoded) return token;
    const updated = { ...decoded, sub: newSub };
    const reenc = encodeBase64Url(updated);
    const tamperedJWT = parts.length >= 3 ? `${parts[0]}.${reenc}.${parts[2]}` : reenc;
    // console.log(tamperedJWT);
    return tamperedJWT;
  } catch {
    return token;
  }
}

// Helper to decode a JWT payload (base64url) safely
function decodeJwtPayload(token: string): any | null {
  try {
    const parts = token.split('.');
    if (parts.length < 2) return null;
    const base64url = parts[1];
    const base64 = base64url.replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64.padEnd(Math.ceil(base64.length / 4) * 4, '=');
    const json = atob(padded);
    return JSON.parse(json);
  } catch {
    return null;
  }
}

// Helper to base64url-encode a JSON string
function encodeBase64Url(obj: any): string {
  const json = JSON.stringify(obj ?? {});
  const base64 = btoa(json);
  return base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/g, '');
}
*/
